/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import React from 'react';
import DatePicker from 'react-datepicker';
import { CalendarContainer } from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { Box } from '@material-ui/core';
import en from 'date-fns/locale/en-GB';
import ar from 'date-fns/locale/ar-SA';

const CalenderLocalClock = ({
  isRTL,
  label,
  value,
  onChange,
  format = 'dd/MM/yyyy',
  time,
  width = 150,
  minDate,
  maxDate,
  ...rest
}: any) => {
  const locale = isRTL ? ar : en;

  return (
    <Box style={{ width }}>
      <DatePicker
        selected={value}
        onChange={onChange}
        dateFormat={format}
        locale={locale}
        minDate={minDate}
        maxDate={maxDate}
        showTimeSelect={time}
        timeFormat="HH:mm"
        calendarContainer={CalendarContainer}
        placeholderText={label}
        className="form-control"
      />
    </Box>
  );
};

export default CalenderLocalClock;
